import React from 'react';

import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    margin: '20px auto 0 auto',
    padding: '0 20px'
  },
  image: {
    // A definite height lets SVGs that only have a viewBox (no width/height) size
    // from their aspect ratio instead of collapsing inside the flex column.
    height: '60px',
    width: 'auto',
    maxWidth: '70%',
    objectFit: 'contain'
  }
});

// The application's icon (displayable.content.appIconUrl), shown above the /gn step
// titles when an application turns on `showAppIcon`.
const AppIcon = ({ classes, url, name }) => {

  if (!url) {
    return null;
  }

  return (
    <div className={classes.container}>
      <img className={classes.image} src={url} alt={name || ''} />
    </div>
  );
};

export default withStyles(styles)(AppIcon);
